import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from '../../actions'
import { formatName } from '../../helpers'

class StatusChanger extends Component {
  constructor (props) {
    super(props)

    this.state = {
      status: '',
      saving: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    this.setState({ status: this.props.attending_status })
  }

  onSubmit (ev) {
    ev.preventDefault()
    if (this.state.status === this.props.attending_status) {
      this.props.dispatch(actions.displayAlert('There is no change to save.'))
      return
    }
    this.props.dispatch(actions.changePlayerStatus({ id: this.props.id, status: this.state.status }))
    this.setState({ saving: true })
  }

  componentWillReceiveProps (nextProps) {
    nextProps.attending_status !== this.props.attending_status &&
      nextProps.close(nextProps.id)
  }

  render () {
    return (
      <div className='change-status-container'>
        {this.state.saving && <div className='saving-msg'>Saving...</div>}
        <div className='cell-subject changer-name'>
          <Link to={`/player/${this.props.id}`} target='_blank' className='color-inherit'>
            {formatName(this.props.name).length > 15 ? formatName(this.props.name).slice(0, 12) + '...' : formatName(this.props.name)}
          </Link>
        </div>
        <form className='status-form' onSubmit={this.onSubmit}>
          <input
            type='radio'
            name='status'
            value='invited'
            className='radio-bttn'
            checked={this.state.status === 'invited'}
            onChange={() => this.setState({ status: 'invited' })} />
          <span className='bttn-info' onClick={() => this.setState({ status: 'invited' })}>invited</span>
          <input
            type='radio'
            name='status'
            value='active'
            className='radio-bttn'
            checked={this.state.status === 'active'}
            onChange={() => this.setState({ status: 'active' })} />
          <span className='bttn-info' onClick={() => this.setState({ status: 'active' })}>active</span>
          <input
            type='radio'
            name='status'
            value='arrived'
            className='radio-bttn'
            checked={this.state.status === 'arrived'}
            onChange={() => this.setState({ status: 'arrived' })} />
          <span className='bttn-info' onClick={() => this.setState({ status: 'arrived' })}>arrived</span>
          <input
            type='radio'
            name='status'
            value='other'
            className='radio-bttn'
            checked={['invited', 'active', 'arrived'].indexOf(this.state.status) === -1}
            onChange={() => this.setState({ status: this.refs.other && this.refs.other.value })} />
          <input type='text' className='status-text' onChange={(ev) => this.setState({ status: ev.target.value })} ref='other' />
          <input type='submit' value='✓' className='button button-sm save-bttn cursor-pointer' />
          <input type='button' value='✕' className='button button-sm cancel-bttn cursor-pointer' onClick={() => this.props.close(this.props.id)} />
        </form>
      </div>
    )
  }
}

export default connect()(StatusChanger)



// WEBPACK FOOTER //
// ./src/screens/administration/StatusChanger.js